import React, { useState } from 'react';
import { resourceLimits } from 'worker_threads';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { globals } from '../../misc/globals';
import { mapDivEnterToClick, setFocus } from '../../misc/tools';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

import './AARUI.css'

var currentFocusedItem = '';

var data: AARData =  {
	scenarios: [
		{
			summary: 'On Saturday morning, a patient with a tracheostomy unexpectedly is decannulated by a well-meaning family member trying to adjust the trach ties for the patient\'s comfort. The patient goes into respiratory arrest and, after multiple attempts to re-establish the airway, is successfully re-cannulated and transferred to the ICU.',
			assessmentSections: [
				{
					summary: 'When a medical emergency is sounded, you should:',
					items: {
						bestAnswers: [1],
						collection: [
							'Look up policies on the nurses’ station computer.',
							'Go to Medical Emergency code room.',
							'Determine re-staffing for Medical Emergency Code primary RN.'
						]
					}
				},
				{
					summary: 'When you’re in the Emergency Code room and RN Heather and the STAT Team are busy with the patient, you should:',
					items: {
						bestAnswers: [1],
						collection: [
							'Re-staff RN Heather’s patients.',
							'Move the family members out of the room.'
						]
					}
				},
				{
					summary: 'When you decide to move family members out of the room, you should:',
					items: {
						bestAnswers: [1],
						collection: [
							'Escort the family members out of the room myself.',
							'Tell LPN Jamie to escort the family members out of the room.'
						]
					}
				},
				{
					summary: 'Which report(s) would the following statement be added to? An in-patient was accidentally decannulated by a family member. Patient went into cardiac arrest and a Medical Emergency Code was activated. Patient was resuscitated and transferred to ICU.',
					items: {
						bestAnswers: [1, 2, 3],
						collection: [
							'None',
							'Incident Report',
							'End of Shift Report',
							'24 Hour Report',
						]
					}
				},
			]
		},
		{
			summary: 'Miranda is a new-graduate RN who has recently joined your staff and just finished her preceptorship. One of her patients needs a blood transfusion since she lost a large amount of blood during her mastectomy two days ago. The patient’s Hematocrit level is 27. RN Miranda was introduced to performing blood transfusions during her VA orientation, but she has never done it by herself. Miranda is nervous that she will not be able to identify an adverse transfusion reaction, so she would like some help from a more experienced RN.',
			assessmentSections: [
				{
					summary: 'When RN Miranda asks for help with a blood transfusion, you should say:',
					items: {
						bestAnswers: [0],
						collection: [
							'Let’s look up our facility’s policies on transfusions.',
							'Can I help you later?',
							'Sure! I can help you now!'
						]
					}
				},
				{
					summary: 'When you’ve looked at the policy and RN Miranda asks “what should I do?”, you should say:',
					items: {
						bestAnswers: [0],
						collection: [
							'You’ll have to first prep the patient for the transfusion.',
							'I’ll prep the patient for you while you get the blood.'
						]
					}
				},
				{
					summary: 'When RN Miranda has prepped the patient and asks for help to verify and monitor the patient during transfusion, you should say:',
					items: {
						bestAnswers: [1],
						collection: [
							'First, go get the blood from the lab. We can deal with the verification after.',
							'Okay, go ahead and find a second RN to help you verify and monitor.',
							'I’ll verify for you and help monitor the patient.'
						]
					}
				}
			]
		},
		{
			summary: 'Mr. Zolic is ready to be discharged. Before he lets him leave, RN Marco would like you to take one final look at his charts and ensure the discharge checklist is complete.',
			assessmentSections: [
				{
					summary: 'When RN Marco asks what he should do when Mr. Zolic’s discharge orders have come and his wife is waiting for him, you should say:',
					items: {
						bestAnswers: [1],
						collection: [
							'Go ahead and discharge him. He’s good to go.',
							'First take his vital signs. We need to be sure he\'s healthy.'
						]
					}
				},
				{
					summary: 'When RN Marco returns after the patient’s vitals have been taken and Marco asks if there is anything else he should do, you should say:',
					items: {
						bestAnswers: [1],
						collection: [
							'No. go ahead and discharge him.',
							'Review the discharge orders.'
						]
					}
				},
				{
					summary: 'Which report(s) would the following statement be added to? Patient was discharged without incident (foot infection from Diabetic Neuropathy).',
					items: {
						bestAnswers: [2, 3],
						collection: [
							'None',
							'Incident Report',
							'End of Shift Report',
							'24 Hour Report',
						]
					}
				}
			]
		},
		{
			summary: 'One of your staff RNs, Ben, approaches you. It’s 2300. He says, "I just received a call from the doctor. The doctor reviewed the tests on our patient in room 429, and the doctor found she has an emergent appendicitis. The problem is she only speaks Thai, and her husband has gone home for the evening. What should I do?',
			assessmentSections: [
				{
					summary: 'When RN Ben wants to know how he can get a non-English speaking patient to sign a consent form, you should say:',
					items: {
						bestAnswers: [3],
						collection: [
							'We are going to have to delay the surgery until the morning. We do not have any access to interpreters during night shifts.',
							'Call her husband. He can provide informal interpreter services over the phone.',
							'Just have Mrs. Srisati sign the form. We will brief her after the procedure, in the morning.',
							'I need to look up our facility’s policies for interpreter services before proceeding.'

						]
					}
				},
				{
					summary: 'When can local staff provide interpretation services?',
					items: {
						bestAnswers: [0],
						collection: [
							'Only for common or daily nursing care instructions. ',
							'Only for official medical forms.',
							'For all patient care needs and medical forms',
							'Never'
						]
					}
				},
				{
					summary: 'Which report(s) would the following statement be added to? Interpreter services were used to communicate surgery rationale and obtain consent.',
					items: {
						bestAnswers: [2, 3],
						collection: [
							'None',
							'Incident Report',
							'End of Shift Report',
							'24 Hour Report',
						]
					}
				}
			]
		},
		{
			summary: 'RN Heather is doing an SBAR handoff en route to ICU following a Medical Emergency/Code Blue. Heather’s patients will need to be re-staffed until she returns.',
			assessmentSections: [
				{
					summary: 'Based on the current Staffing Plan, how many patients does each staff currently have?',
					items: {
						bestAnswers: [],
						bestAnswersStaffing: [4, 4, 4, 5, 0],
						collection: [
							'Heather:  0, 1, 2, 3, 4, 5, 6',
							'Marco:  0, 1, 2, 3, 4, 5, 6',
							'Miranda:  0, 1, 2, 3, 4, 5, 6',
							'Ben:  0, 1, 2, 3, 4, 5, 6',
							'You (Charge Nurse):  0, 1, 2, 3, 4, 5, 6'
						]
					}
				},
				{
					summary: 'Given that Marco and Miranda each have four patients while Ben has five patients, which is the best option to re-staff Heather’s remaining three patients?',
					items: {
						bestAnswers: [2],
						collection: [
							'Assign extra patients to a nurse who already has a patient in isolation.',
							'Assign extra patients to a nurse who is exhibiting evidence of being overwhelmed.',
							'Assign patients with low acuity levels to a nurse who is training and may lack confidence.',
							'Assign additional patients to a nurse who already has patients on opposite ends of the floor.'

						]
					}
				}
			]
		}
	]
}

var activeQuestions: AARQuestion[] = null;

const AARUI = (props: UIProperties<AARUIConfig>) => {
	const [activeScenarioIndx, setActiveScenarioIndx] = useState(-1);
	const [showPassFailScreen, setshowPassFailScreen] = useState(false);

	const activeScenario: AARScenario = data.scenarios[activeScenarioIndx];

	const updateActiveScenario = (scenarioIndx: number) => {
		if(scenarioIndx >= data.scenarios.length) {
			scenarioIndx = 0;
		} else if(scenarioIndx < 0) {
			scenarioIndx = data.scenarios.length - 1;
		}

		activeQuestions = props.parameters.questions.filter(q => q.scenarioId === scenarioIndx);

		if(scenarioIndx === data.scenarios.length - 1) {
			var staffingPlanQuestion = props.parameters.questions.find(q => typeof q.chosenBenPatients !== 'undefined');

			if(staffingPlanQuestion) {
				activeQuestions.push(staffingPlanQuestion)
			}
		}

		// setFocus('arr-item-summary');
		setFocus(currentFocusedItem);
		setActiveScenarioIndx(scenarioIndx);
	}

	if(activeScenarioIndx === -1) {
		updateActiveScenario(0);
		return;
	}
	const displayPassFailScreen= () => {
		return (
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '1690px',
				pointerEvents: 'all',
				zIndex: 1000
			}} tabIndex={0} id='section-game-completed' aria-label="Game Completed Screen">
				<img src="./assets/images/general/backgrounds/level-completed.png" />
				<p tabIndex={0} className="title-font" style={{
					margin: '0',
					position: 'absolute',
					top: '260px',
					left: '0px',
					fontSize: '100px',
					width: '100%',
					textAlign: 'center',
					color: props.parameters.passed ? 'green' : 'red'
				}}>{props.parameters.passed ? 'Great Job!' : 'Try Again!'}</p>
				<p tabIndex={0} className="title-font" style={{
					margin: '0px',
					position: 'absolute',
					top: '410px',
					left: '0px',
					fontSize: '70px',
					width: '100%',
					textAlign: 'center'
				}}>{'Score: ' + props.parameters.score + '%'}</p>
				<p tabIndex={0} className="title-font" style={{
					margin: '0px',
					position: 'absolute',
					top: '540px',
					left: '0px',
					fontSize: '70px',
					width: '100%',
					textAlign: 'center',
					color: props.parameters.passed ? 'green' : 'red'
				}}>{props.parameters.passed ? 'PASS' : 'FAIL'}</p>
				{!props.parameters.passed ? <p className="title-font" style={{
					margin: '0px',
					position: 'absolute',
					top: '670px',
					left: '0px',
					fontSize: '70px',
					width: '100%',
					textAlign: 'center'
				}} tabIndex={0}>Please retake assessment.</p>:(null)}
				{props.parameters.passed ?<div style={{
					position: 'absolute',
					top: '730px',
					left: '50%',
					transform: 'translate(-50%, 0)',
					width: '210px',
    				height: '90px'
				}}>
					<GeneralButtonWithText parameters= {{
						text: 'Exit Game',
						id:'aar-ui-last',
						top: '0',
						left: '0',
						width: '215px',
						srcIdle: "./assets/images/general/buttons/button_main.png",
						srcHighlight: "./assets/images/general/buttons/button_main.png",
						onClicked: props.parameters.onExitClicked
					}}/>
				</div> : (null)}

				{!props.parameters.passed ?<div style={{
					position: 'absolute',
					top: '800px',
					left: '50%',
					transform: 'translate(-50%, 0)',
					width: '440px',
    				height: '90px'
				}}>
					<GeneralButtonWithText parameters= {{
						text: 'Retry',
						top: '0',
						left: '0',
						width: '215px',
						srcIdle: "./assets/images/general/buttons/button_main.png",
						srcHighlight: "./assets/images/general/buttons/button_main.png",
						onClicked: props.parameters.onRetryClicked
					}}/>
					<GeneralButtonWithText parameters= {{
						text: 'Exit Game',
						top: '0',
						left: '230px',
						width: '215px',
						id:'aar-ui-last',
						srcIdle: "./assets/images/general/buttons/button_main.png",
						srcHighlight: "./assets/images/general/buttons/button_main.png",
						onClicked: props.parameters.onExitClicked
					}}/>
				</div> : (null)}
			</div>
		);
	};

	const displayAar = () => {
		return (<div className="splashaar-fadein ui-top-most-container modal-bg" style={{
			pointerEvents: 'all'
		}}>
			<div style={{
				width: '92%',
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)'
			}} tabIndex={0} id='aar-ui-first' aria-label='After Action Review'>
				<img src="./assets/images/general/components/aar/window_aar.png"/>
				<p className="title-font" style={{
					position: 'absolute',
					top: '6px',
					left: '0',
					margin: '0',
					textAlign: 'center',
					width: '100%'
				}}>Debriefing</p>

				<GeneralButtonWithText parameters= {{
					srcIdle: './assets/images/general/components/aar/button_next_main.png',
					srcHighlight: './assets/images/general/components/aar/button_next_down.png',
					text: 'Back',
					top: '70px',
					left: '20px',
					width: '147.33px',
					id: 'section-prev-button',
					customImgStyle: {
						transform: 'scaleX(-1)',
						left: '-5px'
					},
					onClicked: () => {
						currentFocusedItem = 'section-prev-button';

						updateActiveScenario(activeScenarioIndx-1);
					}
				}}/>
				<div style={{
					display: 'grid',
					gridTemplateColumns: (() => {
						var result = '';
						for(var scenarioIndx = 0; scenarioIndx < data.scenarios.length; scenarioIndx++) {
							if(scenarioIndx > 0) {
								result += ' ';
							}

							result += 'auto';
						}
						return result
					})(),
					width: '740px',
					position: 'absolute',
					top: '61px',
					left: '50%',
					transform: 'translate(-50%, 0)'
				}}>
					{data.scenarios.map((s: any, index: number) => {
						return (
						<div key={Tools.generateGuid()} style={{
							position: 'relative',
							left: (-25 * index) + 'px'
						}}>
							<div style={{
								
							}}>
								<img className="pointer" style={{maxWidth: 'none'}} id={'section-' + index} src={(() => {
									var tabIteration = index === 0 ? 1 : 2;
									var activeState = activeScenarioIndx === index ? "down" : "main";
									return "./assets/images/general/components/aar/tab_aar_" + tabIteration + "_" + activeState + ".png";
								})()} onMouseEnter={() => {
									var rollOverAudio = document.getElementById('button-rollover');
									
									if(!globals.isMuted) {
										(rollOverAudio as any).play();
									}
								}} tabIndex={0} aria-label={'Scenario ' + (index + 1)} onKeyUp={mapDivEnterToClick} onClick={() => {
									var clickAudio = document.getElementById('button-click');
									currentFocusedItem = 'section-' + index;
									if(!globals.isMuted) {
										(clickAudio as any).play();
									}
									updateActiveScenario(index);
								}}/>
								<p style={{
									position: 'absolute',
									margin: '0',
									top: '4px',
									left: '0',
									width: '87%',
									textAlign: 'center',
									pointerEvents: 'none',
									fontSize: '20pt'
								}}>Scenario</p>

								<p style={{
									position: 'absolute',
									margin: '0',
									top: '26px',
									left: '0',
									width: '87%',
									textAlign: 'center',
									fontSize: '40pt',
									fontWeight: 'bold',
									pointerEvents: 'none'
								}}>{index + 1}</p>
							</div>
						</div>);
					})}
				</div>
				
				<GeneralButtonWithText parameters= {{
					srcIdle: './assets/images/general/components/aar/button_next_main.png',
					srcHighlight: './assets/images/general/components/aar/button_next_down.png',
					id: 'section-next-button',
					text: 'Next',
					top: '70px',
					left: '1530px',
					width: '147.33px',
					customImgStyle: {
					},
					onClicked: () => {
						currentFocusedItem = 'section-next-button';

						updateActiveScenario(activeScenarioIndx+1);
					}
				}}/>

				<img style={{
					position: 'absolute',
					top: '149px',
					width: '1691px',
					left: '1px'
				}} src="./assets/images/general/components/aar/divider_aar_horizontal.png"/>

				<div style={{
					position: 'absolute',
					top: '158px',
					left: '10px',
					width: '1670px',
					height: '150px',
					overflow: 'auto'
				}}>
					<p className="font-title" style={{
						margin: '0',
						fontSize: '20pt'
					}} tabIndex={0} id='arr-item-summary' aria-label={'scenario ' + (activeScenarioIndx + 1) + ' summary. ' + activeScenario.summary}>{activeScenario.summary}</p>
				</div>

				<img style={{
					position: 'absolute',
					top: '308px',
					width: '1691px',
					left: '1px'
				}} src="./assets/images/general/components/aar/divider_aar_horizontal.png"/>
				<div style={{
					position: 'absolute',
					left: '2px',
					top: '313px',
					width: '1687px'
				}}>
					<div style={{
						position: 'absolute',
						width: '100%',
						left: '2px'
					}}>
						<img style={{
						}} src="./assets/images/general/components/aar/bar_aar_large.png"/>
						<p className="font-title" style={{
							margin: '0',
							position: 'absolute',
							top: '10px',
							left: '10px',
							fontSize: '20pt'
						}} tabIndex={0}>ASSESSMENT OF YOUR RESPONSES</p>
					</div>

					<img style={{
						position: 'absolute',
						top: '50px',
						width: '1691px',
						left: '1px'
					}} src="./assets/images/general/components/aar/divider_aar_horizontal.png"/>

					<div style={{
						position: 'absolute',
						top: '53px',
						left: '2px',
						width: '1685px',
						height: '520px',
						overflowY: 'auto',
						overflowX: 'hidden'
					}}>
						{activeScenario.assessmentSections.map((section: AARAssessmentSection, sectionIndex: number) => {
							return (<div key={Tools.generateGuid()} style={{
								position: 'relative',
								top: '0',
								left: '0',
								width: '100%'
							}}>
								<p className="title-font" style={{
									fontSize: '24pt',
									margin: '0',
									position: 'relative',
									top: '3px',
									left: '10px',
									width: '1030px'
								}}  tabIndex={0}>{section.summary}</p>
		
								<img style={{
									position: 'relative',
									top: '20px',
									width: '1632px',
									left: '1px'
								}} src="./assets/images/general/components/aar/divider_aar_horizontal.png"/>
		
								<p className="title-font" style={{
									fontSize: '24pt',
									margin: '0',
									position: 'absolute',
									top: '3px',
									left: '1133px',
									width: '224px',
									textAlign: 'center'
								}}>Your Response</p>
		
								<p className="title-font" style={{
									fontSize: '24pt',
									margin: '0',
									position: 'absolute',
									top: '3px',
									left: '1416px',
									width: '187px',
									textAlign: 'center'
								}}>Best Answer</p>

								{section.items.collection.map((collectionItem: string, collectionItemIndx: number) => {
									var question: AARQuestion = null; //this will only have something if the user picked this entry

									if(collectionItem.indexOf('0, 1, 2, 3') !== -1) {
										//staffing plan question
										question = activeQuestions[activeQuestions.length - 1]; //staffing plan question answers are always the last in the questions array
									} else {
										for(var qIndx = 0; qIndx < activeQuestions.length; qIndx++) {
											var iteratedQuestion = activeQuestions[qIndx];
											
											if(!iteratedQuestion.collectionId){
												console.warn('Collection ID is null for Scenario ID ' + iteratedQuestion.scenarioId + ' and Section ID ' + iteratedQuestion.sectionId);
											}

											if( iteratedQuestion.scenarioId === activeScenarioIndx &&
												iteratedQuestion.sectionId === sectionIndex &&
												iteratedQuestion.collectionId &&
												iteratedQuestion.collectionId.indexOf(collectionItemIndx) !== -1) {
													question = iteratedQuestion;
													break;
												}
										}
									}

									const getText = () => {
										if(collectionItem.indexOf('0, 1, 2, 3') !== -1) {
											if(section.items.bestAnswersStaffing[collectionItemIndx] === question.chosenHeatherPatients.currentCount) {
												return 'you put that ' + collectionItem.split(':')[0] + ' has ' + question.chosenHeatherPatients.currentCount + '. this is the best answer'
											} else {
												return 'you put that ' + collectionItem.split(':')[0] + ' has ' + question.chosenHeatherPatients.currentCount + '. this is not the best answer. The best answer was ' + section.items.bestAnswersStaffing[collectionItemIndx] + '. '
											}
										}
										else if(question && typeof question.chosenBenPatients === 'undefined') {
											if(section.items.bestAnswers.indexOf(collectionItemIndx) !== -1) {
												return 'the following is one of the selections you made. This is the best response. ". ' + collectionItem +'". '
											} else {
												return 'the following is one of the selections you made. This is not the best response. ". ' + collectionItem +'". '
											}
										} else if(!question) {
											if(section.items.bestAnswers.indexOf(collectionItemIndx) !== -1) {
												return 'the following is not a selection you made. however. it is the best response. ". ' + collectionItem +'". '
											} else {
												return 'the following is not a selection you made. and it is also not the best response.". ' + collectionItem +'". '
											}
										}
									}


									return (<div key={Tools.generateGuid()} style={{
										position: 'relative',
										top: collectionItemIndx === 0 ? '15px' : '15px',
										left: '0',
										width: '100%'
									}}>
										<div style={{
										}}>
											<p className="title-font" style={{
												fontSize: '14pt',
												margin: '0',
												position: 'relative',
												top: '3px',
												left: '25px',
												fontWeight: 'normal',
												width: '710px'
											}} tabIndex={0} id={activeScenarioIndx === 4 ? '' : (sectionIndex === activeScenario.assessmentSections.length - 1 && collectionItemIndx === section.items.collection.length - 1 ? 'aar-ui-last' : '')} aria-label={getText()}>{collectionItem}</p>
											<br />
											<img style={{
												position: 'absolute',
												bottom: '0',
												width: '1632px',
												left: '1px'
											}} src="./assets/images/general/components/aar/divider_aar_horizontal.png"/>
			
											{question && typeof question.chosenBenPatients === 'undefined' ? (<div style={{
												position: 'absolute',
												top: '1px',
												width: '284px',
												height: '38px',
												left: '1103px',
											}}>
												<img style={{
													position: 'absolute',
													top: '50%',
													width: '30px',
													left: '50%',
													transform: 'translate(-50%, -50%)'
												}} src={(() => {
													var isCorrect = false;

													isCorrect = question && section.items.bestAnswers.indexOf(collectionItemIndx) !== -1;
													
													return "./assets/images/general/components/aar/" + (isCorrect ? "GreenCheck" : "RedX") + ".png";
												})()}/>
											</div>) : (null)}

											{question && typeof question.chosenBenPatients !== 'undefined' ? (<div style={{
												position: 'absolute',
												top: '1px',
												width: '284px',
												height: '38px',
												left: '1103px'
											}}>
												<p className="title-font" style ={{
													margin: '0',
													width: '100%',
													textAlign: 'center',
													position: 'absolute',
													top: '50%',
													transform: 'translate(0, -50%)'
												}}>{(() =>{
													if(collectionItem.toLocaleLowerCase().startsWith('heather')) {
														return question.chosenHeatherPatients.currentCount;
													} else if(collectionItem.toLocaleLowerCase().startsWith('marco')) {
														return question.chosenMarcoPatients.currentCount;
													} else if(collectionItem.toLocaleLowerCase().startsWith('mirand')) {
														return question.chosenMirandaPatients.currentCount;
													} else if(collectionItem.toLocaleLowerCase().startsWith('ben')) {
														return question.chosenBenPatients.currentCount;
													} else if(collectionItem.toLocaleLowerCase().startsWith('you')) {
														return question.chosenYouPatients.currentCount;
													} else {
														return '';
													}
												})()}</p>
											</div>) : (null)}

											{section.items.bestAnswers.indexOf(collectionItemIndx) !== -1 ? 
												(<div style={{
													position: 'absolute',
													top: '1px',
													width: '243px',
													height: '38px',
													left: '1388px',
												}}>
													<img style={{
														position: 'absolute',
														top: '50%',
														width: '30px',
														left: '50%',
														transform: 'translate(-50%, -50%)'
													}} src="./assets/images/general/components/aar/GreenCheck.png"/>
												</div>) 
												: (null)}

											{section.items.bestAnswersStaffing ? (<div style={{
												position: 'absolute',
												top: '1px',
												width: '243px',
												height: '38px',
												left: '1388px'
											}}>
												<p className="title-font" style ={{
													margin: '0',
													width: '100%',
													textAlign: 'center',
													position: 'absolute',
													top: '50%',
													transform: 'translate(0, -50%)'
												}}>{section.items.bestAnswersStaffing[collectionItemIndx]}</p>
											</div>) : (null)}
										</div>
									</div>);
								})}	
								<img style={{
									position: 'relative',
									width: '1632px',
									left: '1px',
									height: '5px'
								}} src="./assets/images/general/components/aar/bar_aar_small.png"/>						
							</div>);
						})}
					</div>


					<img style={{
						position: 'absolute',
						top: '55px',
						height: '613px',
						width: '2px',
						left: '1103px'
					}} src="./assets/images/general/components/aar/divider_aar_vertical.png"/>

					<img style={{
						position: 'absolute',
						top: '55px',
						height: '613px',
						width: '2px',
						left: '1388px'
					}} src="./assets/images/general/components/aar/divider_aar_vertical.png"/>

					<img style={{
						position: 'absolute',
						top: '55px',
						height: '613px',
						width: '2px',
						left: '1633px'
					}} src="./assets/images/general/components/aar/divider_aar_vertical.png"/>
				
					<GeneralButtonWithText parameters= {{
						srcIdle: './assets/images/general/components/aar/button_submit_main.png',
						srcHighlight: './assets/images/general/components/aar/button_submit_down.png',
						text: 'Close',
						// isNotTabbable: activeScenarioIndx !== 4,
						id: activeScenarioIndx !== 4 ? '' : 'aar-ui-last',
						top: '589px',
						left: '760px',
						width: '197.33px',
						customImgStyle: {
						},
						onClicked: () => {
							setFocus('section-game-completed')
							setshowPassFailScreen(true);
						}
					}}/>
				</div>
			</div>
		</div>)
	}
	return (
		showPassFailScreen ? displayPassFailScreen() : displayAar()
	);

};

export interface AARUIConfig {
	questions: AARQuestion[];
	score: number;
	passed: boolean;
	onRetryClicked: () => void;
	onExitClicked: () => void;
}

export interface AARQuestion {
	scenarioId: number;
	sectionId: number;
	collectionId: number[];

	chosenHeatherPatients?: ChosenPatients;
	chosenMarcoPatients?: ChosenPatients;
	chosenMirandaPatients?: ChosenPatients;
	chosenBenPatients?: ChosenPatients;
	chosenYouPatients?: ChosenPatients;
}

export interface ChosenPatients {
	name: string;
	currentCount: number;
}

interface AARData {
	scenarios: AARScenario[];
}

interface AARScenario {
	summary: string;
	assessmentSections: AARAssessmentSection[];
}

interface AARAssessmentSection {
	summary: string;
	items: AARAssessmentSectionItem;
}

interface AARAssessmentSectionItem {
	bestAnswers: number[];
	bestAnswersStaffing?: number[];
	collection: string[];
}

export default AARUI;